<div class="toolbar" fxLayout="row" fxLayoutAlign="space-between">
  <div fxLayout="row" fxLayoutAlign="start center">
    <fury-toolbar-sidenav-mobile-toggle (openSidenav)="openSidenav.emit()"></fury-toolbar-sidenav-mobile-toggle>
    <h1>Meldingen Openbare Ruimte</h1>
  </div>
  <div fxLayout="row">
    <fury-toolbar-webform-link *ngIf="webformUrlExists" class="toolbar-button"></fury-toolbar-webform-link>

    <fury-toolbar-darkmode-toggle class="toolbar-button"></fury-toolbar-darkmode-toggle>

    <fury-toolbar-fullscreen-toggle class="toolbar-button"></fury-toolbar-fullscreen-toggle>
  </div>
</div>

